"use client";

import { BSRCheck } from "./bsr/BSRCheck";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Check as LegacyCheck } from "./legacy/Check";

export const Check = createBSRExperimentIcon(LegacyCheck, BSRCheck);
